<template>
  <w-sliding-popup ref="slidingPopup" :title="dumpfileName" width="800px" @close="closePopup">
    <div slot="content">
      <el-input v-loading="isLoading" readonly type="textarea" v-model="fileDumpContent" :autosize="{ minRows: 40 }"></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import ApmConfigAPI from '@/api/config/apm/apm-info';

export default {
  name: 'WFileDumpPopup',
  props: {
    fileDumpParams: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      fileDumpContent: '',
      dumpfileName: '',
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    fileDumpParams: {
      handler() {
        if (Object.entries(this.fileDumpParams).length > 0) {
          this.loadData();
          this.dumpfileName = this.fileDumpParams.name;
        }
      },
      immediate: true,
    },
  },
  methods: {
    initModel() {
      this.fileDumpContent = '';
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
      this.initModel();
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    loadData() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      const params = {
        objId: this.selectedNode.obj.objId,
        fileName: this.fileDumpParams.name,
      };
      ApmConfigAPI.getDumpFileDetail(params).then((response) => {
        if (response.data.success) {
          this.fileDumpContent = response.data.data;
        }
        this.isLoading = false;
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/apm/snapshot/popup/FileDumpPopup.vue